import type { ActivatedRouteSnapshot } from '@angular/router';

const SENSITIVE_PARAM = /token|secret|pass|code/i;

export interface RouteDescription {
    /** El patrón de la ruta (`/app/shipment/details/:id`): agrupa visitas sin partirlas por id. */
    pattern: string;
    params?: Record<string, string>;
}

/**
 * Reconstruye el patrón de la ruta activa recorriendo el árbol del router, y junta sus parámetros.
 * Un parámetro con nombre de secreto (`/reset/:token`) se queda en el patrón pero no en los valores.
 */
export function describeRoute (root: ActivatedRouteSnapshot, url: string): RouteDescription {
    const segments: string[] = [];
    const params: Record<string, string> = {};

    for (let node: ActivatedRouteSnapshot | null = root; node; node = node.firstChild) {
        const path = node.routeConfig?.path;
        if (path && path !== '**') segments.push(path);
        for (const [key, value] of Object.entries(node.params ?? {})) {
            if (!SENSITIVE_PARAM.test(key)) params[key] = String(value);
        }
    }

    const pattern = segments.length ? `/${segments.join('/')}` : (url.split(/[?#]/)[0] || '/');
    return Object.keys(params).length ? { pattern, params } : { pattern };
}
